import { IconProps } from "../../../types/style";

const RoutingSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M8.88003 5.09973C8.08003 1.63973 2.87002 1.62973 2.07002 5.09973C1.60002 7.12973 2.89003 8.84973 4.01003 9.91973C4.83003 10.6897 6.12003 10.6897 6.94003 9.91973C8.06003 8.84973 9.34003 7.12973 8.88003 5.09973ZM5.51003 6.69973C4.96003 6.69973 4.51003 6.24973 4.51003 5.69973C4.51003 5.14973 4.95003 4.69973 5.50003 4.69973H5.51003C6.07003 4.69973 6.51003 5.14973 6.51003 5.69973C6.51003 6.24973 6.07003 6.69973 5.51003 6.69973Z"
          fill={color}
        />
        <path
          d="M6.51001 5.7002C6.51001 6.2502 6.07001 6.7002 5.51001 6.7002C4.96001 6.7002 4.51001 6.2502 4.51001 5.7002C4.51001 5.1502 4.95001 4.7002 5.50001 4.7002H5.51001C6.07001 4.7002 6.51001 5.1502 6.51001 5.7002Z"
          fill={color}
        />
        <path
          opacity="0.4"
          d="M21.91 17.0997C21.11 13.6397 15.88 13.6297 15.07 17.0997C14.6 19.1297 15.89 20.8497 17.02 21.9197C17.84 22.6897 19.14 22.6897 19.96 21.9197C21.09 20.8497 22.38 19.1297 21.91 17.0997ZM18.53 18.6997C17.98 18.6997 17.53 18.2497 17.53 17.6997C17.53 17.1497 17.97 16.6997 18.52 16.6997H18.53C19.08 16.6997 19.53 17.1497 19.53 17.6997C19.53 18.2497 19.08 18.6997 18.53 18.6997Z"
          fill={color}
        />
        <path
          d="M19.53 17.7002C19.53 18.2502 19.08 18.7002 18.53 18.7002C17.98 18.7002 17.53 18.2502 17.53 17.7002C17.53 17.1502 17.97 16.7002 18.52 16.7002H18.53C19.08 16.7002 19.53 17.1502 19.53 17.7002Z"
          fill={color}
        />
        <path
          d="M11.9999 20.25H9.31994C8.15994 20.25 7.14994 19.55 6.74994 18.47C6.33994 17.39 6.63994 16.2 7.50994 15.43L15.4999 8.44C15.9799 8.02 15.9899 7.45 15.8499 7.06C15.6999 6.67 15.3199 6.25 14.6799 6.25H11.9999C11.5899 6.25 11.2499 5.91 11.2499 5.5C11.2499 5.09 11.5899 4.75 11.9999 4.75H14.6799C15.8399 4.75 16.8499 5.45 17.2499 6.53C17.6599 7.61 17.3599 8.8 16.4899 9.57L8.49994 16.56C8.01994 16.98 8.00994 17.55 8.14994 17.94C8.29994 18.33 8.67994 18.75 9.31994 18.75H11.9999C12.4099 18.75 12.7499 19.09 12.7499 19.5C12.7499 19.91 12.4099 20.25 11.9999 20.25Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default RoutingSVG;
